module.exports = __webpack_public_path__ + "static/media/cook-islands.766e20f6.svg";